module.exports = __webpack_public_path__ + "img/241.578d5faf.jpg";